const DOCUMENT_LINKS_TAB_SCOPE = 'document-links-tab';

export const DocumentLinksTabTestIds = {
  CANCEL_BUTTON: `${DOCUMENT_LINKS_TAB_SCOPE}.cancel-button`,
  SAVE_BUTTON: `${DOCUMENT_LINKS_TAB_SCOPE}.save-button`,
  EDIT_BUTTON: `${DOCUMENT_LINKS_TAB_SCOPE}.edit-button`,
  TASK_GROUP: `${DOCUMENT_LINKS_TAB_SCOPE}.task-group`,
  TASK_NAME: `${DOCUMENT_LINKS_TAB_SCOPE}.task-name`,
  getTypeSelectId: type => `${DOCUMENT_LINKS_TAB_SCOPE}.${type}-select`,
  getAddButtonId: type => `${DOCUMENT_LINKS_TAB_SCOPE}.add-${type}-button`,
  getOpenButtonId: value => `${DOCUMENT_LINKS_TAB_SCOPE}.open-${value}-button`,
  getUnlinkButtonId: value => `${DOCUMENT_LINKS_TAB_SCOPE}.unlink-${value}-button`,
};
